export const BASIC_LOAN_DATA_KEY = 'BASIC_LOAN_DATA';
export const EMPLOYEE_LOAN_CATEGORIES_KEY = 'EMPLOYEE_LOAN_CATEGORIES';
